import CourseDetail from './CourseDetail';
import Courses from './Courses';
import Institucional from './Institucional';
import Layout from './Layout';
import Login from './Login';
import NoticeDetail from './NoticeDetail';
import OnMobile from './OnMobile';
import PostDetail from './PostDetail';
import PostList from './PostList';
import Product from './Product';
import SaleDetail from './SaleDetail';
import SaleList from './SaleList';

export {
  CourseDetail, Courses, Institucional, Layout, Login, NoticeDetail, OnMobile,
  PostDetail,
  PostList,
  Product, SaleDetail, SaleList
};




// WEBPACK FOOTER //
// ./src/screens/index.js